import { type CanonicalSchema, deepFreeze, CanonicalFieldType as T } from './canonical-schema.js'

/**
 * `organization-unit@1` — owned by the organization bounded context
 * (organization-service): the unit fields that map to existing organization
 * columns and the unit's PRIMARY location (O2) address, geo and contact fields.
 * TO-539 replaced the unused five-field placeholder with these fields (the
 * former `@2`) in place — a one-time exception, safe only because no stored
 * import definition targeted either version. APPEND-ONLY from here on: never
 * edit this published version; publish `organization-unit.v2.ts` instead.
 */
export const ORGANIZATION_UNIT_V1: CanonicalSchema = deepFreeze({
	name: 'organization-unit',
	version: 1,
	owner: 'organization',
	fields: [
		{ name: 'externalCode', type: T.STRING, required: true, nullable: false, maxLength: 64 },
		{ name: 'name', type: T.STRING, required: true, nullable: false, maxLength: 200 },
		{ name: 'parentExternalCode', type: T.STRING, required: false, nullable: true, maxLength: 64 },
		{ name: 'type', type: T.STRING, required: true, nullable: false, maxLength: 64 },
		{ name: 'active', type: T.BOOLEAN, required: true, nullable: false, maxLength: null },
		{ name: 'externalId', type: T.STRING, required: false, nullable: true, maxLength: 128 },
		{ name: 'institutionCode', type: T.STRING, required: false, nullable: true, maxLength: 32 },
		{ name: 'shortName', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'isPhysical', type: T.BOOLEAN, required: false, nullable: true, maxLength: null },
		{ name: 'validFrom', type: T.DATE, required: false, nullable: true, maxLength: null },
		{ name: 'validTo', type: T.DATE, required: false, nullable: true, maxLength: null },
		{ name: 'addressLine1', type: T.STRING, required: false, nullable: true, maxLength: 200 },
		{ name: 'addressLine2', type: T.STRING, required: false, nullable: true, maxLength: 200 },
		{ name: 'postalCode', type: T.STRING, required: false, nullable: true, maxLength: 16 },
		{ name: 'city', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'province', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'region', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'countryCode', type: T.STRING, required: false, nullable: true, maxLength: 2 },
		{ name: 'latitude', type: T.DECIMAL, required: false, nullable: true, maxLength: null },
		{ name: 'longitude', type: T.DECIMAL, required: false, nullable: true, maxLength: null },
		{ name: 'phone', type: T.STRING, required: false, nullable: true, maxLength: 32 },
		{ name: 'email', type: T.STRING, required: false, nullable: true, maxLength: 254 },
	],
})
